module.exports = __webpack_public_path__ + "static/media/cartAddWhite.10e42372.svg";